import axios from "@/plugins/axios";

let url = "/api/plugins/nanuri/giftcard";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
}